// disabling eslint temporarily for files until they can be refactored
/* eslint-disable */
import React from "react";
import { Col, Row } from "react-bootstrap";
import clsx from "clsx";
import styles from "./infoBox.scss";

/**
 * Primary Info Box UI component for user interaction
 */
const InfoBox = (props) => {
  const { labels, allCompanies, noData, title } = props;

  return (
    <div>
      <h6>{title}</h6>

      <div className={styles.boxBody}>
        <Row style={{ marginBottom: 10 }}>
          <Col md="8">
            <span className={clsx("ml-4", styles.darkGray)}>
              Configuration Method
            </span>
          </Col>
          <Col md="4">
            <span className={clsx("ml-4", styles.darkGray)}>
              # of {allCompanies ? "Tenants" : "Employees"}
            </span>
          </Col>
        </Row>
        {labels.map((item, index) => {
          if (item.value === undefined) {
            return;
          }
          return (
            <Row key={index} className={"mt-1"}>
              <Col md="8">
                <span
                  className={clsx(
                    "ml-4",
                    item.value === 0 ? styles.lightGray : styles.normalBlack
                  )}
                >
                  {" "}
                  {item.key}
                </span>
              </Col>
              <Col md="4">
                <span
                  className={clsx(
                    "ml-4",
                    item.value === 0 ? styles.lightGray : styles.normalBlack
                  )}
                >
                  {item.value}
                </span>
              </Col>
            </Row>
          );
        })}
      </div>
    </div>
  );
};

export { InfoBox };
